module.exports = __webpack_public_path__ + "img/paypal.60239ee.png";